import request from '@/utils/request'

export function checkPurchased(userId, courseType, courseLevel) {
  return request({
    url: `/ordera/check/${userId}`,
    method: 'get',
    params: { courseType, courseLevel }
  })
}

export function createOrder(data) {
  return request({
    url: '/ordera/create',
    method: 'post',
    data
  })
}

export function mockPayOrder(orderNo) {
  return request({
    url: `/ordera/mock-pay/${orderNo}`,
    method: 'post'
  })
}

export function getOrderByNo(orderNo) {
  return request({
    url: `/ordera/detail/${orderNo}`,
    method: 'get'
  })
}

export function listOrdersByUserId(userId, courseType, courseLevel) {
  const params = {}
  if (courseType) params.courseType = courseType
  if (courseLevel) params.courseLevel = courseLevel

  return request({
    url: `/ordera/list/${userId}`,
    method: 'get',
    params: Object.keys(params).length ? params : undefined
  })
}

export function cancelOrder(orderNo) {
  return request({
    url: `/ordera/cancel/${orderNo}`,
    method: 'post'
  })
}
